import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import Stripe from 'stripe';

// import { PaymentIntent } from '@stripe/stripe-js';
// import getStripe from '@util/stripe/get-stripejs';
// import Stripe from 'stripe';
// import { stripe } from '@lib/stripe';
import { PaymentStatus } from '@modules/payment/complete/PaymentStatus';
import { fetchPostJSON } from '@util/stripe/api-helpers';

// import { Elements } from '@stripe/react-stripe-js';

const PaymentStatusPage = () => {
  const router = useRouter();
  const [paymentIntent, setPaymentIntent] = useState<Stripe.PaymentIntent>();

  const { payment_intent } = router.query;
  // payment_intent=pi_3RGGD9BxBWf9F5vn1KN7KCIR
  // &payment_intent_client_secret=pi_3RGGD9BxBWf9F5vn1KN7KCIR_secret_LPRVacfvbSRwfYbMQMh927QQx
  // &redirect_status=succeeded

  useEffect(() => {
    if (payment_intent && !paymentIntent) {
      fetchPostJSON('/api/stripe/confirm-payment-intent', {
        payment_intent,
      }).then((data) => {
        setPaymentIntent(data);
      });
    }
  }, [payment_intent]);

  if (router.isFallback || !paymentIntent) {
    return <div>Loading...</div>;
  }
  // return <div>{JSON.stringify(paymentIntent)}</div>;
  return <PaymentStatus paymentIntent={paymentIntent} />;
};

PaymentStatusPage.getLayout = (page: any) => <>{page}</>;

export default PaymentStatusPage;
